import React from "react";
import { useSelector } from "react-redux";
import { Separator } from "@radix-ui/react-separator";

import { PricingCitiesSlider } from "../../../components/pricing/pricing-cities-slider";
import { NewCityCreationForm } from "../../../components/pricing/new-city-creation-form";
import { NewZoneCreationForm } from "../../../components/pricing/new-zone-creation-form";
import { PricingView } from "../../../components/pricing/pricing-view";

export default function Pricing() {
  const newCityCreationMode = useSelector(
    ({ pricing }) => pricing.newCityCreationMode
  );

  const currentSelectedCityId = useSelector(
    ({ pricing }) => pricing.currentSelectedCityId
  );

  const pricing = useSelector(({ pricing }) => pricing);

  return (
    <>
      <div className="bg-black sticky top-0 z-40 py-4 px-4">
        <div className="rounded-md w-full">
          <PricingCitiesSlider />
        </div>
      </div>
      <div className="bg-black relative px-2 lg:px-4">
        <div className="text-white max-md:min-h-[calc(100svh_-_12rem)] md:h-[calc(100svh_-_8.1rem)] overflow-hidden grid md:grid-cols-[14rem_auto_1fr] lg:grid-cols-[18rem_auto_1fr] xl:grid-cols-[20rem_auto_1fr] rounded-md w-full gap-x-2">
          <div className="overflow-x-visible overflow-y-scroll scrollbar-none space-y-4">
            {newCityCreationMode && <NewCityCreationForm />}
            {!newCityCreationMode && <NewZoneCreationForm />}
          </div>

          <Separator
            orientation="vertical"
            className="my-4 h-px w-full border-r border-dashed border-[#181E29] bg-transparent mx-1 lg:mx-4 md:my-0 md:h-full md:w-px"
          />

          <div className="relative overflow-y-scroll scrollbar-none">
            {!newCityCreationMode && pricing.cities[currentSelectedCityId] && (
              <PricingView />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
